import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routerMap.js'

Vue.use(VueRouter)

const whiteList = ['/','/login','/register', '/404','/shoppingCart','/search','/detail','/shop','/privacyPolicy']

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let hasUrl = false
  for(let one of routes){
    if(one.path === to.path){
      hasUrl = true
      break
    }
  }
  if(!hasUrl){
    next('/404')
    return
  }
  if (!whiteList.includes(to.path)) {
    const userName = sessionStorage.getItem('user_uid')
    if (userName === null) {
      next('/login')
      return
    }
  }
  next()
})

export default router